<template>
	<div class="grid__content">
        <tabs :classTabs = "'mainNavigation-margin'"
                    :classNavigation = "'main-head'"
                    :classItem = "'main-head__tab'"
                    :classActive="'main-head__tab-active'">
              <tab :name="'Информация'" :selected="true">
                  <div class="tabs-wrap">
                    <div class="grid__navigator black-overlay">
                        <scrollbar class="profile-scroll">
                            <div class="profile_blockWidget profile_blockWidget_big-column">
                                <div class="profile_blockWidget-image">
                                    <div class="profile_blockWidget-imageItem">
                                        <a href="https://iqquantum.com/files/diplom_1.pdf" target="_blank">
                                            <img src="../assets/img/diplom_1.png">
                                        </a>
                                    </div>
                                    <div class="profile_blockWidget-imageItem">
                                        <a href="https://iqquantum.com/files/diplom_2.pdf" target="_blank">
                                            <img src="../assets/img/diplom_2.png">
                                        </a>
                                    </div>
                                </div>
                                <div class="profile_blockWidget-text">
                                    <div class="profile_blockWidget-wrap">
                                        <div class="profile_blockWidget-title">
                                            Наши атестаты
                                        </div>
                                        <div class="profile_blockWidget-subtitle">
                                            <a href="http://www.cbr.ru/finmarket/supervision/sv_validation/att_check/" target="_blank">
                                                Проверка статуса<br>квалифицированного атестата
                                            </a>
                                        </div>
                                    </div>
                                    <div class="profile_blockWidget-ico">
										<svg-icon icon-class="icon icon--inline mt-20" icon-name="icon-arrow-next" icon-size="0 0 24 24" icon-fill="#718DA8"></svg-icon>
									</div>
                                </div>
                            </div>
                            <div class="profile_blockWidget profile_blockWidget_vertikal">
                                <div class="profile_blockWidget-text">
                                    <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                                        Прогнозируемая доходность
                                    </div>
                                </div>
                                <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                                    <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                                        15-20% годовых 5-7% волатильность
                                    </div>
                                </div>
                                <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                                    <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                                        25-35% годовых 10-12% волатильность
                                    </div>
                                </div>
                                <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                                    <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                                        40-55% годовых 15-20% волатильность
                                    </div>
                                </div>
                                <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                                    <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                                        50+ % годовых 25-30% волатильность
                                    </div>
                                </div>
                            </div>
                        </scrollbar>
                    </div>
                    <div class= "grid__main-content">
                        <scrollbar class="information-wrap">
                            <div class="profile_blockWidget-header">
                                <div class="profile_blockWidget-header-wrap">
                                    <div class="profile_blockWidget-header_text">
                                        <h1>Информация</h1>
                                        <p>Уважаемый пользователь торговых сигналов, приветсвуем вас на нашем<br>ресурсе и благодарим за выбор нашего сервиса!</p>
                                        <p>Создателем данного ресурса являюсь я Алексей Денисов — аттестованный<br>участник финансового рынка.</p>
                                    </div>
                                    <div class="profile_blockWidget-trader">
                                        <div class="profile_blockWidget-traderAva f-ava f-ava--big">
                                            <img src="../assets/img/adenisov.png" class="f-ava__img">
                                        </div>
                                        <div class="profile_blockWidget-traderName">
                                            <div class="profile_blockWidget-name">
                                                Алексей Денисов
                                            </div>
                                            <div class="profile_blockWidget-status">
                                                Трейдер, управляющий ДУ
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="profile_blockWidget-traderSkils">
                                    <div class="profile_blockWidget-traderSkils-wrap">
                                    <ul class="profile_blockWidget-traderSkilsUl">
                                        <li>Идейный разработчик и инвестиционный <br>менеджер торгового треминала Trade Sharp</li>
                                        <li>Профессиональный управляющий капиталом<br>на фиатном и криптовалютном рынке инвестиций</li>
                                        <li>Многолетние партнёрские отношения<br>с провайдерам ликвидности GMG и CFH</li>
                                        <li>Опыт управления капиталом более чем в <span>$ 10 млн</span></li>
                                    </ul>
                                    <ul class="profile_blockWidget-traderSkilsUl">
                                        <li>Создатель собственной<br>торговой системы</li>
                                        <li>Финансовый<br>консультант</li>
                                        <li>Провайдер торговых сигналов<br>с более 35 000 подписчиков</li>
                                        <li>Опыт трейдинга на валютном рынке <span>25 лет</span></li>
                                    </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="profile_blockWidget-static">
                                <div class="profile_blockWidget-header_text">
                                    <h1>Как мы будем работать.</h1>
                                    <p>Методология или стратегия торговли основывается на принципах, которые представлены в документе где подробно описана
                                        <a class="color-green" href="http://master.forexinvest.com/files/strategy.pdf" target="_blank">торговая стратегия.</a></p>
                                </div>
                                <div class="profile_blockWidget-workWrap">
                                    <h1>Важные аспекты:</h1>
                                    <div class="profile_blockWidget-workItem">
                                        Открытие позиций происходит с периодичностью в Н6
                                    </div>
                                    <div class="profile_blockWidget-workItem">
                                        Редактирование сделок происходит при свершении события.
                                    </div>
                                    <div class="profile_blockWidget-workItem">
                                        «Выстраивание» позиции : расчетная модель с высокой точностью определяет количество резервируемого капитала под конкретную валютную пару, с динамическим перераспределением актива между торгуемыми парами.
                                    </div>
                                    <div class="profile_blockWidget-workItem">
                                        Расчет суммы входа в рынок. Предлагаем ознакомиться с нашим методом.
                                    </div>
                                    <div class="profile_blockWidget-workItem">
                                        Как мы считаем результат:  так как мы все располагаем  разными суммами на счетах и имеем разный аппетит  к  риску , то мы в наших расчетах будем использовать показатели, выраженные в % и «пипсах».  Это позволит вам на своей стороне использовать тот риск, с которым вы привыкли работать и который  комфортен именно вам. Мы ведем детальный учет каждой сделки, что позволяет публиковать и формировать отчет.
                                    </div>
                                </div>
                                <div class="profile_blockWidget-header_text">
                                    <p>Вам стоит с осторожностью подходить к использованию высокого кредитного плеча.</p>
                                    <p>Из опыта можем  сказать следующее: значительные  потери случаются по двум основным причинам- из-за отсутствия внятной, проработанной стратегии и чрезмерного  использование кп.
                                    </p>
                                    <p>"Мы акцентируем внимание на крайне осторожном обращении с левериджом (плечем). Легкомысленное отношение к этому вопросу неизбежно приводит к убыткам. Мы категорически не рекомендуем использовать  двузначный  леверидж(!). Такое злоупотребление риском в долгосрочной перспективе неизбежно приводит к полной(!) потере капитала!"
                                    </p>
                                    <h1>Рекомендуем</h1>
                                    <p>
                                        Для более эффективного использования нашей стратегии, выберите несколько торговых пар, в зависимости от вашего депозита и торгуйте  ими, планомерно увеличивая базовый актив.
                                    </p>
                                    <p>При всей привлекательности данной стратегии, стоит особо отметить  риски, которые неизбежно ложатся на вас!</p>
                                    <p>Помните, что  исполнение наших рекомендаций на стороне вашего брокера.</p>
                                    <p>Так как мы работаем только с профессиональными  участниками рынка, то рекомендуем рассмотреть вопрос открытия вами торгового счета у  одного из провайдеров ликвидности, например  <a class="color-green" href="http://www.gc.exchange" target="_blank">GC Exchange Limited (краткая справка)</a>, регулируемого финансовыми властями Великобритании.</p>
                                    <p>Открыв  торговый счет у  жестко регулируемого провайдера ликвидности , вы получаете минимальные спреды и автоматическое исполнение наших сделок на вашем счету. Жесткий контроль регулятора , под которым находится провайдер, так же  минимизирует  ваши нерыночные риски.</p>
                                    <p>Наше вознаграждение будет заложено в спред, что упростит процесс расчета между нами.</p>
                                    <p>
                                        <span style="display:flex">Мы профессиональные участники рынка и обладаем <span style="margin-left:4px; margin-right:6px"> МАМ-счетом </span> <descrip :direction="'left'" :width="350" :text="'МАМ счет – дословно “Управляющий несколькими счетами” (Multi Account Manager), т.е— это технология, позволяющая управляющему активами эффективно управлять неограниченным количеством счетов инвестора. МАМ счет это одна из современных форм сотрудничества между управляющим и инвесторами, при которой все средства инвестора хранятся на его персональном счете, а управляющий имеет доступ только для управления.'"></descrip></span>
                                        Это позволяет формировать портфель из инвестиционного капитала и торговых счетов. В процессе работы провайдер ликвидности проводит строгий комплайнс-контроль всех участников и гарантирует прозрачность всех проводимых операций.
                                    </p>
                                </div>
                            </div>
                        </scrollbar>
                    </div>
                  </div>
              </tab>
            <tab :name="'Статистика'">
                <div class="staticSignals-wrap">
                    <scrollbar class="staticSignals-widgets">
                        <div class="staticSignals-widgetWrap">
                            <div class="staticSignals-widgetTitle">статистические показатели</div>
                            <div class="staticSignals-widgetsWrap">
                               <div class="staticSignals-widgetItem">
                                   <stat-table :part="'one'"></stat-table>
                               </div>
                               <div class="staticSignals-widgetItem">
                                   <stat-table :part="'two'"></stat-table>
                               </div>
                            </div>
                        </div>
                        <div class="staticSignals-widgetWrap">
                            <div class="staticSignals-widgetTitle">Детально по парам</div>
                            <div class="staticSignals-widgetsWrap">
                               <div class="staticSignals-widgetItem">
                                   <details-pair
                                    :title="'EUR/USD'"
                                    :symbol="'EURUSD'"
                                    :avatar="'EUR-USD'">
                                    </details-pair>
                               </div>
                               <div class="staticSignals-widgetItem">
                                   <details-pair
                                    :title="'GBP/USD'"
                                    :symbol="'GBPUSD'"
                                    :avatar="'GBP-USD'"
                                   ></details-pair>
                               </div>
                            </div>
                            <div class="staticSignals-widgetsWrap">
                               <div class="staticSignals-widgetItem">
                                   <details-pair
                                    :title="'USD/JPY'"
                                    :symbol="'USDJPY'"
                                    :avatar="'JPY-USD'"
                                   ></details-pair>
                               </div>
                               <div class="staticSignals-widgetItem">
                                   <details-pair
                                    :title="'USD/CHF'"
                                    :symbol="'USDCHF'"
                                    :avatar="'EUR-USD'"
                                   ></details-pair>
                               </div>
                            </div>
                            <div class="staticSignals-widgetsWrap">
                               <div class="staticSignals-widgetItem">
                                   <details-pair
                                    :title="'USD/CAD'"
                                    :symbol="'USDCAD'"
                                    :avatar="'USD-CAD'"
                                   ></details-pair>
                               </div>
                               <div class="staticSignals-widgetItem">
                                   <details-pair
                                    :title="'EUR/GBP'"
                                    :symbol="'EURGBP'"
                                    :avatar="'GBP-USD'"
                                   ></details-pair>
                               </div>
                            </div>
                        </div>
                    </scrollbar>
                    <scrollbar class="staticSignals-charts">
                        <div class="staticSignals-chartItem" style="height:700px">
                            <strategy :fullStatus="false"
                                    :mini="true">
                            </strategy>
                        </div>
                        <div class="staticSignals-chartItem">
                            <week-chart :fullStatus="false"
                                    :mini="true"
                                    :summaryData="false">
                            </week-chart>
                        </div>
                        <div class="staticSignals-chartItem">
                            <month-chart :fullStatus="false"
                                    :mini="true"
                                    :summaryData="false">
                            </month-chart>
                        </div>
                    </scrollbar>
                </div>
            </tab>
        </tabs>
        <div class="grid__chat">
            <div class="profile_blockWidget profile_blockWidget-chat">
                <div class="profile_blockWidget-chatWidget">
                    <chat-live :heightBlock="heightContactBlock"></chat-live>
                </div>
                <div class="profile_blockWidget-chatForms" ref="forms_contact">
                    <accordion
                        :dropdown="false"
                        :initialOpenItem="1"
                        :icon="'custom'"
                        :caretAnimation="{
                            duration: '.6s',
                            timerFunc: 'ease-in-out',
                        }"
                        :slide="{
                            duration: '.9s',
                            timerFunc: 'ease',
                        }">
                        <div @click="changeHeight" class="profile_blockWidget contactWidget">
                            <accordion-item :initialOpenItem="true">
                                    <div slot="title">
                                        <div class="contactWidget-title">
                                            <div class="contactWidget-titleText">
                                                <i class="icon-phone"></i>
                                                    Заказать обратный звонок
                                            </div>
                                        </div>
                                    </div>
                                    <i slot="icon-open" class="icon-icon-down"></i>
                                    <i slot="icon-closed" class="icon-icon-up"></i>
                                    <div slot="content">
                                        <div class="contactWidget-form">
                                            <input type="text" class="contactWidget-formInput" placeholder="Укажите ФИО">
                                            <input type="text" class="contactWidget-formInput" placeholder="Укажите номер телефона">
                                            <input type="text" class="contactWidget-formInput" placeholder="Укажите E-mail">
                                            <div class="contactWidget-desc">На указаный адрес мы вышьлем<br>письмо с деталями и возможностями</div>
                                            <div class="contactWidget-submit">Отправить</div>
                                        </div>
                                    </div>
                            </accordion-item>
                        </div>
                        <div @click="changeHeight" class="profile_blockWidget contactWidget">
                            <accordion-item>
                                <div slot="title">
                                    <div class="contactWidget-title">
                                        <div class="contactWidget-titleText">
                                            <i class="icon-invest"></i>
                                            Инвестировать
                                        </div>
                                    </div>
                                </div>
                                <i slot="icon-open" class="icon-icon-down"></i>
                                <i slot="icon-closed" class="icon-icon-up"></i>
                                <div slot="content">
                                    <div class="contactWidget-form">
                                        <input type="text" class="contactWidget-formInput" placeholder="Укажите ФИО">
                                        <input type="text" class="contactWidget-formInput" placeholder="Укажите номер телефона">
                                        <input type="text" class="contactWidget-formInput" placeholder="Укажите E-mail">
                                        <div class="contactWidget-desc">На указаный адрес мы вышьлем<br>письмо с деталями и возможностями</div>
                                        <div class="contactWidget-submit">Отправить</div>
                                    </div>
                                </div>
                            </accordion-item>
                        </div>
                        <div @click="changeHeight" class="profile_blockWidget contactWidget">
                            <accordion-item>
                                <div slot="title">
                                    <div class="contactWidget-title">
                                        <div class="contactWidget-titleText">
                                            <i class="icon-contact"></i>
                                            Контакты
                                        </div>
                                    </div>
                                </div>
                                <i slot="icon-open" class="icon-icon-down"></i>
                                <i slot="icon-closed" class="icon-icon-up"></i>
                                <div slot="content">
                                    <div class="contactWidget-dataWrap">
                                        <div class="contactWidget-dataItem">
                                            <div class="contactWidget-dataText_title">Телефон</div>
                                            <div class="contactWidget-dataText">+7 (903) 808 06 26</div>
                                        </div>
                                        <div class="contactWidget-dataItem">
                                            <div class="contactWidget-dataText_title">E-mail</div>
                                            <div class="contactWidget-dataText">adenisov@forexinvest.com</div>
                                        </div>
                                        <div class="contactWidget-dataItem">
                                            <div class="contactWidget-dataText_title">Skype</div>
                                            <div class="contactWidget-dataText">@fxdenisov</div>
                                        </div>
                                    </div>
                                </div>
                            </accordion-item>
                        </div>
                    </accordion>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LiveChat from './chat/chat-live-trader';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import ProfitStrategy from './profitability/chartsForTabs/pofitInPercent/sig-profit-chart-strategy-widget';
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import StatTable from "./componentsSignalsPage/crop-stat";
import PairDetails from "./componentsSignalsPage/detail-pair";
import { setTimeout } from 'timers';
import Tab from './ui-components/ui-tab';
import Tabs from './ui-components/ui-tabs';
import WeekChart from './profitability/chartsForTabs/profitWeekCharts/sig-profitability-chart-week';
import MonthChart from './profitability/chartsForTabs/profitMonthCharts/sig-profitability-chart-month';
import Descriptions from './ui-components/description';
import svgIcon from './ui-components/svg-icon';
	export default {
		components: {
            "chat-live":LiveChat,
            "scrollbar":VuePerfectScrollbar,
            "strategy": ProfitStrategy,
            "week-chart":WeekChart,
            "month-chart":MonthChart,
            "accordion-item":BulmaAccordionItem,
            "accordion":BulmaAccordion,
            "stat-table":StatTable,
            "tab":Tab,
            "tabs":Tabs,
            "details-pair":PairDetails,
            "descrip":Descriptions,
			"svg-icon":svgIcon
        },
		props: [],
		data() {
			return {
                contact:true,
                invest:true,
                call:false,
				profitWidgets:[ {
                title:'Баланс',
                type: 'balance',
                chart: true,
                param: 'bal'
            },
            {
                title:'Средства',
                type: 'equity',
                chart: true,
                param: 'eq'
            },
            {
                title:'Чистая прибыль',
                type:'plAbs',
                chart: true,
                param: 'plAbs'
            },
            {
                title:'Текущий доход',
                type:'plCur',
                chart: true,
                param:'plCur'
            },
            {
                title:'Изменения за сутки',
                type:'changeDay',
                chart: true,
                param:'changeDay'
            }
            ],
            heightContactBlock:null
			};
		},
		computed: {
			getHeightBlock() {
                 return this.heightContactBlock;
            }
		},
		methods: {
			showContact() {
                this.contact = !this.contact;
            },
            showInvest() {
                this.invest = !this.invest;
            },
            showCall() {
                this.call = !this.call;
            },
            changeHeight() {
                setTimeout(()=>{
                     let heightBlock = this.$refs.forms_contact.offsetHeight;
                    this.heightContactBlock = heightBlock;
                    console.log(this.heightContactBlock)
                },910)

            }
        },
        mounted() {
            let heightBlock = this.$refs.forms_contact.offsetHeight;
            this.heightContactBlock = heightBlock;
        }

	};
</script>
<style lang="less" scoped>
.tabs-wrap {
    display: flex;
}
.information-wrap {
    height: calc(100vh - 144px);
    overflow: auto;
    @media (max-width: 1690px) {
            width: calc(100vw - 444px);
        }
}
.staticSignals {
    &-chartItem {
        margin-left: 4px;
        margin-right: 2px;
        max-width: 100%;
        height: 480px;
        margin-top: 4px;
        &:first-child {
            margin-top: 0px;
        }
        @media (max-width: 1690px) {
            height: 404px;
        }
        @media (min-width: 1930px) {
            height: calc(100vh - 804px);
        }
    }
    &-wrap {
        display: flex;
        margin-left: 2px;
        margin-top: 2px;
    }
    &-widgets {
        width: 724px;
        height: calc(100vh - 144px);
        overflow: auto;
    }
    &-charts {
        width: calc(100vw - 1164px);
        height: calc(100vh - 144px);
        overflow: auto;
        @media (max-width: 1690px) {
            width: calc(100vw - 801px);
        }

    }
    &-widgetWrap {
        background: #3D536B;
        widows: 100%;
        margin-bottom: 4px;
        &:last-child {
            margin-top: 4px;
        }
    }
    &-widgetsWrap {
        display: flex;
    }
    &-widgetItem {
        border-right: 4px solid #293546;
        &:last-child {
            border-right: none;
        }
    }
    &-widgetTitle {
        border-bottom: 1px solid #293546;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: Arimo;
        font-weight: bold;
        font-size: 13px;
        text-transform: uppercase;
    }
}
.profile_blockWidget {
    display: flex;
    width: 360px;
    background: #3D536B;
    margin-bottom: 4px;
    &-image {
        display: flex;
        border-bottom: solid 1px #293546;
        height: 179px;
        display: flex;
        align-items: center;
        padding-left: 12px;
    }
    &-imageItem {
        height: 155px;
        width: 109px;
        margin-right: 12px;
    }
    &-static {
        background: #3D536B;
        width: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        margin-top: 4px;
    }
    &-header {
      background: #3D536B;
      width: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      &-wrap {
          display:flex;
          border-bottom: solid #293546 1px;
      }
      &_text {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 23px;
        flex-grow: 1;
        h1 {
          font-size: 35px;
          font-family: Montserrat;
          font-weight: bold;
        }
        p {
          font-family: Roboto;
          font-size: 20px;
          color:#ADC4E1;
          margin-top: 23px;
        }
        @media (max-width: 1600px) {
            h1 {
                font-size: 25px;
                font-family: Montserrat;
                font-weight: bold;
            }
            div {
                font-family: Roboto;
                font-size: 16px;
                color:#ADC4E1;
                margin-top: 23px;
            }
        }
      }
    }
    &-workWrap {
        border-top: solid #293546 1px;
        padding-left: 23px;
        padding-right: 23px;
        h1 {
            font-size: 35px;
            font-family: Montserrat;
            font-weight: bold;
            margin-top: 12px;
        }
    }
    &-workItem {
        padding-top:23px;
        padding-bottom: 23px;
        font-size: 18px;
        display: flex;
        justify-content: space-between;
        font-family: Montserrat;
        align-items: center;
        color:#ADC4E1;
        border-bottom: solid #293546 1px;
    }
    &-center {
        display: flex;
        margin-top: 4px;
        height: calc(100vh - 275px);
        overflow: hidden;
        //margin-bottom: 4px;
    }
    &-chat {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        overflow: hidden;
        background: #293546;
    }
    &-chatWidget {
        //flex-grow: 1;
        //max-height: 100%;
        //flex-basis: 100%;
    }
    &-chatForms {
        //flex-grow: 1;
        //flex-basis: 100%;
    }
    &-profitDeals {
        display: flex;
        justify-content: space-between;
        &_wrapData {
            padding: 8px 16px;
        }
        &-title {
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.18;
            letter-spacing: .4px;
            text-transform: uppercase;
            color: #fff;
            margin-top: 4px;
        }
        &-chart {
            flex-grow: 1;
            max-width: 180px;
            padding: 8px 16px;
            display: flex;
            justify-content: flex-end;
        }
    }
    &-profitWidget {
        min-width: 360px;
        height: calc(100vh - 264px);
        overflow: auto;
    }
    &-chart {
        max-width: 100%;
        height: calc(100vh - 704px);
        flex-grow: 1;
        &:first-child {
            margin-bottom: 3px;
        }
    }
    &-chartWrap {
        flex-grow: 1;
        margin-left: 4px;
        height: calc(100vh - 275px);
        overflow: auto;
    }
    &-chartPrognosis {
        display: flex;
        width: 100%;
        max-height: 245px;
        border-top: solid #293546 4px;
        &_item {
            flex-basis: 50%;
            flex-grow: 1;
            height: 245px;
            &:first-child {
                border-right: solid #293546 4px;
            }
        }
    }
    &-trader {
        align-items: center;
        display: flex;
        width: 510px;
        padding-right: 23px;
        padding-left: 23px;
        box-sizing: border-box;
    }
    &-traderAva {
        width: 125px;
        height: 125px;
        border-radius: 70px;
        margin-right: 23px;
        overflow: hidden;
        @media (max-width: 1600px) {
            width: 70px;
            height: 70px;
        }
    }
    &-traderName {

    }
    &-name {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 20px;
        letter-spacing: 0.4px;
        color: #FFFFFF;
        margin-bottom: 20px;
    }
    &-status {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 16px;
        letter-spacing: 0.4px;
        color: #ADC4E1;
    }
    &-traderSkils {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        &-wrap {
            display: flex;
            width: 100%;
            padding: 23px;
        }
    }
    &-traderSkilsUl {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        color:#ADC4E1;
        line-height: 20px;
        /* or 143% */
        letter-spacing: 0.4px;
        flex-basis: 50%;
        flex-grow: 1;
        margin-left: 23px;
        span {
            font-size: 70px;
            font-family: Montserrat;
            font-weight: bold;
            color:#fff;
            display: block;
            margin-top: 43px;
        }
        @media (max-width: 1600px) {
             font-size: 16px;
        }
    }
    &_vertikal {
        display: block;
    }
    &_big {
        height: 120px;
        &-column {
            flex-direction: column;
        }
    }
    &_mini {
        height: 70px;
    }
    &-text {
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &_prognosis {
           border-top: 1px solid #293546;
        }
    }
    &-row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #293546;
    }
    &-col {
        width: 50%;
        flex-grow: 1;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px solid #293546;
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 14px;
        /* identical to box height, or 140% */
        letter-spacing: 0.4px;
        color: #FFFFFF;
        &:last-child {
           border-right:none;
        }
    }
    &-title {
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        /* identical to box height, or 167% */
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-bottom: 12px;
        &_noBottom {
            margin-bottom: 0;
        }
        &_prognosis {
            font-family: Arimo;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            /* or 267% */
            letter-spacing: 0.4px;
            text-transform: uppercase;
            color: #00FFD0;
        }
    }
    &-subtitle {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        a {
          color: #ADC4E1;
        }
    }
    &-bigIcon {
        padding: 20px;
        border-right: 1px #293546 solid;
    }
    &-ico {
        color:#718DA8;
        cursor: pointer;
    }
}
.contactWidget {
    flex-direction: column;
    overflow: hidden;
    &:last-child {
        margin-bottom: 0px;
    }
    &-desc {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        margin-top: 12px;
    }
    &-submit {
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 24px;
        /* identical to box height, or 200% */
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-top: 12px;
        margin-bottom: 12px;
        cursor: pointer;
    }
    &-title {
        padding: 12px;
        background: #3D536B;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 1;
        //border-bottom: #293546  1px solid;
        i {
            color:#718DA8;
            cursor: pointer;
        }
    }
    &-titleText {
        display: flex;
        align-items: center;
        i {
            color:#fff;
            font-size: 24px;
            margin-right: 8px;
            margin-bottom: -4px;
        }
    }
    &-form {
        padding-left: 12px;
        display: flex;
        flex-direction: column;
    }
    &-formInput {
        border-bottom: 1px solid #35485E;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        line-height: 14px;
        margin-top: 15px;
        padding-bottom: 4px;
        outline: none;
        /* identical to box height, or 127% */
        color: #CCE0F8 !important;
    }
    &-dataItem {
        padding: 12px;
    }
    &-dataText {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #FFFFFF;
        &_title {
            font-family: Montserrat;
            font-style: normal;
            font-weight: 500;
            font-size: 13px;
            line-height: 20px;
            color: #ADD4E1;
        }
    }
    &-dataWrap {
        z-index: 0;
        overflow: hidden;
    }
}
input[type="text"]::placeholder { color: #CCE0F8; }
.black-overlay {
    background: #293546 !important;
}
.gorizontal {
    flex-direction: row;
    width: 100%;
    align-items: center;
}
.vertical {
    flex-direction: column
}
.profile-scroll {
    max-height: 100%;
}
ul.profile_blockWidget-traderSkilsUl {
    list-style: disc outside !important;
}
ul.profile_blockWidget-traderSkilsUl > li {
    margin-bottom: 30px;
}
</style>
